import React, { useState } from 'react';
import FormModal from '../../components/shared/FormModal';
import { forgotPasswordApi } from '../../api/auth';
import { toast } from '../../components/shared/toast';

function ForgotPasswordModal({ onClose }) {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [resetTokenData, setResetTokenData] = useState(null);

  const validateEmail = (val) => {
    if (!val || !val.trim()) {
      return 'Email address is required.';
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(val.trim())) {
      return 'Please enter a valid email address.';
    }
    return '';
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErr = validateEmail(email);
    if (validationErr) {
      toast.error(validationErr);
      return;
    }

    setIsLoading(true);

    try {
      const res = await forgotPasswordApi(email.trim());
      toast.success(res.message || 'Password reset request submitted.');
      if (res.resetToken) {
        setResetTokenData(res);
      } else {
        onClose();
      }
    } catch (err) {
      toast.error(err.message || 'Failed to process request.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <FormModal isOpen={true} onClose={onClose} title="Reset Your Password">
      {resetTokenData ? (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
          <div style={{ background: '#ecfdf5', border: '1px solid #6ee7b7', padding: '14px', borderRadius: '10px', color: '#065f46', fontSize: '14px' }}>
            <strong>Reset Link Generated:</strong>
            <p style={{ marginTop: '8px', wordBreak: 'break-all', fontSize: '13px' }}>
              <a href={resetTokenData.resetLink} style={{ color: '#0b66e3', fontWeight: '600' }}>
                {resetTokenData.resetLink}
              </a>
            </p>
          </div>
          <button
            type="button"
            className="login-btn"
            style={{ width: '100%' }}
            onClick={onClose}
          >
            Done
          </button>
        </div>
      ) : (
        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '18px' }} noValidate>
          <p style={{ fontSize: '14px', color: '#64748b', lineHeight: '1.5' }}>
            Enter your registered email address below. If an active account matches, we will issue a password reset link.
          </p>

          <div className="form-group">
            <label className="form-label" htmlFor="forgot-email">Email Address</label>
            <div className="input-wrapper">
              <span className="input-icon">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                  <polyline points="22,6 12,13 2,6" />
                </svg>
              </span>
              <input
                id="forgot-email"
                type="email"
                className="form-input"
                placeholder="name@example.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={isLoading}
              />
            </div>
          </div>

          <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end', marginTop: '10px' }}>
            <button
              type="button"
              style={{ padding: '10px 18px', borderRadius: '8px', border: '1px solid #cbd5e1', color: '#475569', fontWeight: '600' }}
              onClick={onClose}
              disabled={isLoading}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="login-btn"
              style={{ width: 'auto', padding: '10px 22px' }}
              disabled={isLoading}
            >
              {isLoading ? 'Sending...' : 'Send Reset Link'}
            </button>
          </div>
        </form>
      )}
    </FormModal>
  );
}

export default ForgotPasswordModal;
